import { jsx } from "react/jsx-runtime";
import { Entity } from "@contember/binding";
import { useComponentClassName, Grid } from "@contember/ui";
import { memo } from "react";
const DataGridContainerGrid = memo(({
  accessor,
  tileSize = 160,
  tile
}) => /* @__PURE__ */ jsx("div", { className: useComponentClassName("data-grid-body-content-grid"), children: /* @__PURE__ */ jsx(Grid, { columnWidth: tileSize, children: !!accessor.length && Array.from(accessor, (entity) => /* @__PURE__ */ jsx(Entity, { accessor: entity, children: tile }, entity.id)) }) }));
DataGridContainerGrid.displayName = "DataGridContainerGrid";
export {
  DataGridContainerGrid
};
//# sourceMappingURL=DataGridContainerGrid.js.map
